/**
 * Formats things, like dates and numbers.
 *
 * File: \src\Formatter.ts
 * Created Date: Sunday, May 19th 2024, 16:53:58
 * Author: Herrmann Sascha (LDC)
 * -----
 * Last Modified: January 28th 2025, 07:53:48
 * Modified By: Herrmann Sascha (LDC)
 * -----
 * Copyright (c) 2017-2024 Liebherr-Digital Development Center GmbH
 */
import { DateTime } from 'luxon';
import { isDate, isString } from 'lodash';

type DateFormatType = Date | DateTime | string;

export default class Formatters {
  public static $format: Formatters;

  /**
   * Makes sure that the sent date is converted into a DateTime instance if needed.
   *
   * @private
   * @param {DateFormatType} value
   * @return {DateTime}
   * @memberof Formatters
   */
  private ensureDateTime(value: DateFormatType): DateTime {
    let date: DateTime;

    if (isDate(value)) {
      date = DateTime.fromJSDate(value);
    } else if (isString(value)) {
      date = DateTime.fromISO(value);
    } else {
      date = DateTime.fromJSDate(value.toJSDate());
    }

    return date;
  }
}
